
<div class="page-content-wrapper">
  <div class="filter-forms-nav pages-title-nav">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 nav-colmn">
          <ul class="page-name-div d-flex align-items-center">
            <li class="back-n-name d-flex align-items-center">
              <a (click)="back()" class="left-arrow"><span class="material-symbols-outlined purple-text">chevron_left</span></a>
              <h3 class="subheader page-main-title">{{'Back' | translate}}</h3>
            </li>
          </ul>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 right-colmn">
          <div class="status-report-colmn">
            <div class="device-id">
              <h6 class="d-id-ttl">{{'Status as of' | translate}}: <span class="d-id">{{sensorRecord.timestamp ? (sensorRecord.timestamp | dateFormat) : ('Never' | translate)}}</span></h6>
            </div>
            <div class="status-icons-div">
              <span><img [src]="icon" alt=""></span>
              <span>
                <mat-icon>
                  <i [class]="batteryPercentageClass"></i>
                  <span class="ml-2">
                    {{sensorRecord.batteryPercentage !== undefined ? sensorRecord.batteryPercentage : '-'}} %
                  </span>
                </mat-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--==page-content-inner wrap==-->
  <div class="page-content-inner-wrap">
    <section class="card-style-sec inner-page-card-sec device-detail-section scroll-section">
      <div class="container-fluid">
        <div class="card-main-title mt-3">
          <h4 class="card-title"> {{sensorName ?? ('Device' | translate)}}: {{sensorId}}</h4>
        </div>
        <div class="row gravimetric-result-row">
          <div class="card-inner-main-div hours-form-div">
            <div class="row">

              <div class="col-lg-12 d-flex calander-menu-div">
                <div id="zoom-buttons" class="hours-buttons">
                  <button (click)="zoom('8h')"
                    [disabled]="isMapLoading" class="button-accent zoom-8h active"><img src="assets/images/time.png">8H</button>
                    <button (click)="zoom('3d')"
                      [disabled]="isMapLoading" class="button-primary zoom-3d"><img src="assets/images/time.png">3D</button>
                      <button (click)="zoom('1m')"
                        [disabled]="isMapLoading" class="button-primary zoom-1m"><img src="assets/images/time.png">1M</button>
                        <button (click)="zoom('all')"
                          [disabled]="isMapLoading" class="button-primary zoom-all"><img src="assets/images/time.png">ALL</button>
                        </div>
                        <div class="inputs-form-div">
                          <mat-form-field>
                            <mat-label>{{'From Date' | translate}}</mat-label>
                            <input matInput [(ngModel)]="fromDate" class="clickable" [owlDateTime]="dtStart"
                              [owlDateTimeTrigger]="dtStart" required />
                              <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtStart">
                                <i class="fas fa-calendar-alt"></i>
                              </mat-icon>
                              <mat-error>{{'From Date is required' | translate}}</mat-error>
                              <owl-date-time #dtStart></owl-date-time>
                            </mat-form-field>
                            <mat-form-field>
                              <mat-label>{{'To Date' | translate}}</mat-label>
                              <input matInput [(ngModel)]="toDate" class="clickable" [owlDateTime]="dtEnd"
                                [owlDateTimeTrigger]="dtEnd" required />
                                <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="dtEnd">
                                  <i class="fas fa-calendar-alt"></i>
                                </mat-icon>
                                <mat-error>{{'To Date is required' | translate}}</mat-error>
                                <owl-date-time #dtEnd></owl-date-time>
                              </mat-form-field>
                              <div class="calander-border-div from-calander from-select">
                                <h4>{{'Parameter(s)' | translate}}</h4>
                                <div class="from-select-div">
                                  <mat-form-field>
                                    <!--<mat-label>Parameter(s)</mat-label>-->
                                    <mat-select [(ngModel)]="selectedParams" multiple required>
                                      @for (param of parameters; track trackById(index, param); let index = $index) {
                                        <mat-option [value]="param.id">
                                          {{param.value}}
                                        </mat-option>
                                      }
                                    </mat-select>
                                    <mat-icon matPrefix class="mr-3">
                                      <i class="fas fa-chart-line"></i>
                                    </mat-icon>
                                    <mat-error>{{'Parameter is required' | translate}}</mat-error>
                                  </mat-form-field>

                                </div>
                              </div>
                              <button class="custom-main-btn ml-2 px-4" [class.button-spinner]="isMapLoading"
                              (click)="search()" [disabled]="isDisabled() || isMapLoading">{{'Plot' | translate}}</button>

                              <button class="custom-main-btn ml-2 px-3"
                              (click)="export()" [disabled]="!fromDate || !toDate || isMapLoading">{{'Export' | translate}}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row infograph-table-map-row">
                      <div class="col-md-12 col-lg-8">
                        <div class="card-inner-main-div">
                          <div class="col" (resized)="onResized($event)">
                            <div [id]="CHART_DIV_ID" style="width: 100%; height: 800px;"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-4">
                        <div class="sensor-map-div">
                          <div class="table-responsive mb-8">
                            <table class="table mb-0">
                              <thead>
                                <tr>
                                  <th></th>
                                  @for (param of columnParameters; track trackByIndex($index)) {
                                    <th>
                                      {{param | mapLookup: paramNamesById}}
                                    </th>
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{{'Average' | translate}} [{{paramUnit}}]</td>
                                  @for (param of columnParameters; track trackByIndex($index)) {
                                    <td class="ng-star-inserted">
                                      {{deviceAverage[param] | number:'1.0-2'}}
                                    </td>
                                  }
                                </tr>
                                <tr>
                                  <td>{{'Peak' | translate}} [{{paramUnit}}]</td>
                                  @for (param of columnParameters; track trackByIndex($index)) {
                                    <td class="ng-star-inserted">
                                      {{devicePeak[param] | number:'1.0-2'}}
                                    </td>
                                  }
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="google-map-device-detail">
                            <app-device-details-map-clusterer [loading]="true"></app-device-details-map-clusterer>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row ml-3 mr-3" [hidden]="isVideoChartHidden">
                      <div class="col-lg-8 pl-4 pr-4" (resized)="onVideoResized($event)">
                        <div [id]="CHART_VIDEO_DIV_ID" style="width: 100%; height: 150px;"></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-8 p-0">
                        @if (videoResource) {
                          <app-lazy-video-player [videoResource]="videoResource"
                            (onPlayerReadyEmit)="onPlayerReady($event)">
                          </app-lazy-video-player>
                        }
                      </div>
                    </div>

                    <div class="clearfix"></div>
                  </div>
                </section>

              </div><!--==page-content-inner wrapper end==-->
            </div>


